import {createSlice} from "@reduxjs/toolkit";
import {getPhotos} from "./action";

const initialState = {
  state: [],
  loading: true,
  error: ''
} as BaseState<Photo[]>

const slice = createSlice({
  name: 'photoSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPhotos.pending, (state) => ({
        ...state,
        loading: true
      })
    )
    builder.addCase(getPhotos.fulfilled, (state, action) => {
        const photosPagination = action.payload
        return {
          state: [...photosPagination.items],
          loading: false,
          error: null
        }
      }
    )
    builder.addCase(getPhotos.rejected, () => ({
        state: [],
        loading: false,
        error: 'Failed to get photos, please try again'
      })
    )
  }
})

export default slice
